import React from 'react';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

const MARQUEE_ITEMS: readonly string[] = [
  'Building AI-powered homebuyer tools at Nest Navigate',
  'Egyptian Ratscrew multiplayer card game',
  'VS Code theme rotation extension — 12 custom themes',
  'Interview Helper app — modular listening modes',
  'React + TypeScript + AWS Amplify',
  'Los Banos, CA → Los Angeles',
];

interface MarqueeTickerProps {
  isLoaded: boolean;
}

const MarqueeTicker: React.FC<MarqueeTickerProps> = ({ isLoaded }) => {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  const renderTrack = (ariaHidden: boolean) => (
    <span className="marquee-track-half" aria-hidden={ariaHidden}>
      {MARQUEE_ITEMS.map((item, idx) => (
        <React.Fragment key={`${ariaHidden ? 'b' : 'a'}-${idx}`}>
          <span className="marquee-item">{item}</span>
          <span className="marquee-separator" aria-hidden="true">·</span>
        </React.Fragment>
      ))}
    </span>
  );

  return (
    <div
      ref={ref}
      className={`marquee-ticker scroll-reveal ${isVisible ? 'is-visible' : ''} ${isLoaded ? 'animate-in' : ''}`}
      aria-label="Recent work highlights"
    >
      <div className="marquee-track">
        {renderTrack(false)}
        {renderTrack(true)}
      </div>
    </div>
  );
};

export default React.memo(MarqueeTicker);
